import { render, staticRenderFns } from "./GlobalNotification.vue?vue&type=template&id=0f01b389&scoped=true"
import script from "./GlobalNotification.vue?vue&type=script&lang=ts"
export * from "./GlobalNotification.vue?vue&type=script&lang=ts"
import style0 from "./GlobalNotification.vue?vue&type=style&index=0&id=0f01b389&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f01b389",
  null
  
)

export default component.exports